import { default as familyMembersTypes } from "./types";

const {
  FETCH_FAMILY_MEMBERS_REQUEST,
  FETCH_FAMILY_MEMBERS_SUCCESS,
  FETCH_FAMILY_MEMBERS_FAILURE,
} = familyMembersTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAMILY_MEMBERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_FAMILY_MEMBERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_FAMILY_MEMBERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
